export enum PageMode {
	LIST = 'List',
	SELECT_LIST = 'SelectList',
	CREATE = 'Create',
	EDIT = 'Edit',
	VIEW = 'View',
}

export class PageModeUtils {
	static isList(value?: string) {
		return typeof value === 'string' && value.toUpperCase() === PageMode.LIST.toUpperCase();
	}

	static isSelectList(value?: string) {
		return typeof value === 'string' && value.toUpperCase() === PageMode.SELECT_LIST.toUpperCase();
	}

	static isCreate(value?: string) {
		return typeof value === 'string' && value.toUpperCase() === PageMode.CREATE.toUpperCase();
	}

	static isEdit(value?: string) {
		return typeof value === 'string' && value.toUpperCase() === PageMode.EDIT.toUpperCase();
	}

	static isView(value?: string) {
		return typeof value === 'string' && value.toUpperCase() === PageMode.VIEW.toUpperCase();
	}

	static getModeByDefaultView(value?: string): PageMode {
		switch (true) {
			case PageModeUtils.isList(value):
				return PageMode.LIST;
			case PageModeUtils.isSelectList(value):
				return PageMode.SELECT_LIST;
			case PageModeUtils.isCreate(value):
				return PageMode.CREATE;
			case PageModeUtils.isEdit(value):
				return PageMode.EDIT;
			default:
				return PageMode.VIEW;
		}
	}
}
